import { theme } from '@features/executive-report/domain/theme';
import { ShapeProps } from '@features/powerpoint';

export const chartBackgroundOptions = [
  {
    fill: {
      color: theme.colors.lightBlue,
      transparency: 90,
    },
  },
  {
    fill: {
      color: theme.colors.inmarketGreen,
      transparency: 95,
    },
  },
  {
    fill: {
      color: theme.colors.darkGray,
      transparency: 49,
    },
  },
  {
    fill: {
      color: theme.colors.darkGray,
      transparency: 49,
    },
  },
] as const satisfies readonly ShapeProps['options'][];
